import * as yup from "yup";

import { AutocompleteItem } from "../../../components/Autocomplete";
import { defaultCountry } from "../../../shared";
import { radioValidator } from "../../../utilities/validators";
import {
  cityValidatorRequired,
  countryValidatorRequired,
  provinceValidatorRequired,
  registrationNumberValidatorRequired,
} from "../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = yup.object().shape({
  [ComponentId.IS_LEASE_CLIENT]: yup.boolean().default(true), // Zawsze ustawia wartosc na true - JIRA LPPLWEBMOB-750
  [ComponentId.VEHICLE_REGISTRATION_NUMBER]:
    registrationNumberValidatorRequired,
  [ComponentId.VEHICLE_CITY]: cityValidatorRequired,
  [ComponentId.VEHICLE_DRIVEABLE]: yup
    .string()
    .when(ComponentId.IS_LEASE_CLIENT, {
      is: true,
      then: radioValidator,
    }),
  [ComponentId.COUNTRY_REPAIR]: countryValidatorRequired,
  [ComponentId.PROVINCE_REPAIR]: yup.string().when(ComponentId.COUNTRY_REPAIR, {
    is: (country: AutocompleteItem) => country.value === defaultCountry.value,
    then: provinceValidatorRequired,
  }),
  [ComponentId.CITY_REPAIR]: cityValidatorRequired,
});
